import React from 'react';
import './Contact.css';

const Contact: React.FC = () => {

  return (
    <div className="contact-page">
      <div className="contact-container">
        <div className="contact-header">
          <h1 className="contact-title">Contact our team</h1>
          <p className="contact-description">
            Got any questions about the product or scaling on our platform? We're here to help. 
            Chat to our friendly team 24/7 and get onboard in less than 5 minutes.
          </p>
        </div>

        <div className="contact-content">
          <div className="contact-methods-section">
            <div className="contact-method">
              <h3 className="method-title">Chat with us</h3>
              <p className="method-description">Speak to our friendly team via email.</p>
              <div className="method-actions">
                <a href="mailto:support@prepwise.com" className="method-link">
                  <span className="method-icon">✈️</span>
                  <span>Shoot us an email</span>
                </a>
              </div>
            </div>

            <div className="contact-method">
              <h3 className="method-title">Call us</h3>
              <p className="method-description">Call our team Mon-Fri from 8am to 5pm.</p>
              <a href="tel:+19124811085" className="method-link phone-link">
                <span className="method-icon">📞</span>
                <span>+1 (912) 481-1085</span>
              </a>
            </div>

            <div className="contact-method">
              <h3 className="method-title">Visit us</h3>
              <p className="method-description">Chat to us in person at our Statesboro HQ.</p>
              <a 
                href="https://maps.google.com/?q=62+East+Main+Street+Statesboro+GA+30458" 
                target="_blank" 
                rel="noopener noreferrer"
                className="method-link address-link"
              >
                <span className="method-icon">📍</span>
                <span>62 East Main Street<br />Statesboro, GA 30458</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;

